import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  ion-footer {
    padding-bottom: 30px;
  }

  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
    }

    .description {
      margin: 30px auto 0;
      flex-grow: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }

    .animation {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .disclaimer {
      text-align: center;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 0);
      width: 100%;
      max-width: 330px;
      padding: 0 10px;
    }

    .link {
      height: unset !important;
      padding: unset;
      border: unset;
      --background: unset !important;
      font-size: 0.9em !important;
      min-height: 0.9em;
      text-decoration: underline;

      &::part(native) {
        color: rgba(128, 62, 255);
        --ripple-color: transparent;
        --padding-bottom: 0.7em;
        --padding-end: 0.1em;
        --padding-start: 0.3em;
        --padding-top: 0.1em;

        &::after {
          content: none;
        }
      }
    }
  }
`;
